class NswowAccordion {
  constructor() {
    this.accordions = document.querySelectorAll('.ns-nswow-accordion');
    this.initializeAccordions();
  }

  initializeAccordions() {
    this.accordions.forEach((accordion) => {
      const header = accordion.querySelector('.ns-nswow-accordion__head');
      const toggleButton = accordion.querySelector('.ns-nswow-accordion__button');

      if (header) {
        header.addEventListener('click', () => {
          const isOpen = accordion.classList.contains('is-open');

          // Close all accordions safely
          this.accordions.forEach((acc) => {
            acc.classList.remove('is-open');
            const button = acc.querySelector('.ns-nswow-accordion__button');
            if (button) button.classList.remove('active');
          });

          // Safely toggle the current accordion
          if (!isOpen) {
            accordion.classList.add('is-open');
            if (toggleButton) toggleButton.classList.add('active');
          } else {
            accordion.classList.remove('is-open');
            if (toggleButton) toggleButton.classList.remove('active');
          }

        });
      }
    });
  }
}

export default NswowAccordion;
